import ImgLoading from './loading.png';

export function BlockLoading() {
  return (
    <div className="absolute inset-0  flex items-center justify-center">
      <img style={{ width: 78, height: 103 }} src={ImgLoading} alt="loading" />
    </div>
  );
}

export default BlockLoading;
